export const AppConstants = {
  x: 'https://x.com/The_Goddess_AI',
  telegramChatGroup: 'https://t.me/GoddessAI_chat',
  telegramApp: 'https://t.me/GoddessAiBot',
  discord: 'https://discord.gg/PsyyRHA5',
};
